export const SUBMIT = 'app/NonprofitsImportPage/SUBMIT';
export const SUBMIT_FAILED = 'app/NonprofitsImportPage/SUBMIT_FAILED';
export const SUBMIT_SUCCESS = 'app/NonprofitsImportPage/SUBMIT_SUCCESS';

export interface SubmitAction {
  type: typeof SUBMIT;
  data: { nonprofitIds: string[] };
}
export const submitAction = (data: { nonprofitIds: string[] }): SubmitAction => ({
  type: SUBMIT,
  data,
});

export const submitSuccessAction = () => ({
  type: SUBMIT_SUCCESS,
});

export const submitFailedAction = () => ({
  type: SUBMIT_FAILED,
});
